import * as React from 'react'
import styled from 'styled-components'
import './../styles/style.css'
import Header from './Header'
import Footer from './Footer'
import CookieBanner from './CookieBanner'
const LayoutWrapper = styled.div`
padding : 64px 32px;
max-width: 1400px;
margin: 0 auto;
`
export const Layout = ({ isHomepage, children, navigation }) => (
  <LayoutWrapper>
    <Header  />
    {/* <CookieBanner/> */}
    {children}
    <Footer />
  </LayoutWrapper>
)
